export enum CompanyProduct {
  Card = 'Card',
  PayrollLoan = 'Payroll Loan',
}
